import { regex } from './common'
export default regex('landLine', /^[0-9]{10}$/)